import { render } from "./IconMail.vue?vue&type=template&id=3eaf43e6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3eaf43e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3eaf43e6', __exports__)) {
    api.reload('3eaf43e6', __exports__)
  }
  
  module.hot.accept("./IconMail.vue?vue&type=template&id=3eaf43e6", () => {
    api.rerender('3eaf43e6', render)
  })

}


export default __exports__